"use strict";

require("core-js/modules/es.symbol.js");
require("core-js/modules/es.array.index-of.js");
require("core-js/modules/es.object.assign.js");
require("core-js/modules/es.object.define-property.js");
require("core-js/modules/es.object.keys.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _core = require("../../core");
var _eero = require("../../theme/eero");
var _excluded = ["id", "forceBorder", "fullWidthContent", "showFullBorder", "thickBorder", "title", "isInlay", "children"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function cov_19fjrgvlpp() {
  var path = "/__w/code/code/js/packages/bricks/src/deprecated/UNSAFE_layout/ContentCard.tsx";
  var hash = "10d618a1704ebbf98f4d8227a6fef70350ee77ac";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/deprecated/UNSAFE_layout/ContentCard.tsx",
    statementMap: {
      "0": {
        start: {
          line: 18,
          column: 40
        },
        end: {
          line: 21,
          column: 1
        }
      },
      "1": {
        start: {
          line: 24,
          column: 49
        },
        end: {
          line: 77,
          column: 1
        }
      },
      "2": {
        start: {
          line: 35,
          column: 2
        },
        end: {
          line: 76,
          column: 9
        }
      },
      "3": {
        start: {
          line: 79,
          column: 0
        },
        end: {
          line: 79,
          column: 40
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 24,
            column: 49
          },
          end: {
            line: 24,
            column: 50
          }
        },
        loc: {
          start: {
            line: 35,
            column: 2
          },
          end: {
            line: 76,
            column: 9
          }
        },
        line: 35
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 41,
            column: 16
          },
          end: {
            line: 41,
            column: 45
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 41,
            column: 26
          },
          end: {
            line: 41,
            column: 38
          }
        }, {
          start: {
            line: 41,
            column: 41
          },
          end: {
            line: 41,
            column: 45
          }
        }],
        line: 41
      },
      "1": {
        loc: {
          start: {
            line: 42,
            column: 23
          },
          end: {
            line: 42,
            column: 72
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 42,
            column: 37
          },
          end: {
            line: 42,
            column: 43
          }
        }, {
          start: {
            line: 42,
            column: 46
          },
          end: {
            line: 42,
            column: 72
          }
        }],
        line: 42
      },
      "2": {
        loc: {
          start: {
            line: 42,
            column: 46
          },
          end: {
            line: 42,
            column: 72
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 42,
            column: 63
          },
          end: {
            line: 42,
            column: 68
          }
        }, {
          start: {
            line: 42,
            column: 71
          },
          end: {
            line: 42,
            column: 72
          }
        }],
        line: 42
      },
      "3": {
        loc: {
          start: {
            line: 43,
            column: 23
          },
          end: {
            line: 43,
            column: 64
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 43,
            column: 37
          },
          end: {
            line: 43,
            column: 49
          }
        }, {
          start: {
            line: 43,
            column: 52
          },
          end: {
            line: 43,
            column: 64
          }
        }],
        line: 43
      },
      "4": {
        loc: {
          start: {
            line: 46,
            column: 20
          },
          end: {
            line: 46,
            column: 73
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 46,
            column: 37
          },
          end: {
            line: 46,
            column: 69
          }
        }, {
          start: {
            line: 46,
            column: 72
          },
          end: {
            line: 46,
            column: 73
          }
        }],
        line: 46
      },
      "5": {
        loc: {
          start: {
            line: 54,
            column: 20
          },
          end: {
            line: 54,
            column: 72
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 54,
            column: 20
          },
          end: {
            line: 54,
            column: 32
          }
        }, {
          start: {
            line: 54,
            column: 37
          },
          end: {
            line: 54,
            column: 51
          }
        }, {
          start: {
            line: 54,
            column: 55
          },
          end: {
            line: 54,
            column: 66
          }
        }, {
          start: {
            line: 54,
            column: 71
          },
          end: {
            line: 54,
            column: 72
          }
        }],
        line: 54
      },
      "6": {
        loc: {
          start: {
            line: 63,
            column: 5
          },
          end: {
            line: 74,
            column: 5
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 63,
            column: 5
          },
          end: {
            line: 63,
            column: 10
          }
        }, {
          start: {
            line: 64,
            column: 6
          },
          end: {
            line: 73,
            column: 16
          }
        }],
        line: 63
      },
      "7": {
        loc: {
          start: {
            line: 75,
            column: 5
          },
          end: {
            line: 75,
            column: 78
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 75,
            column: 24
          },
          end: {
            line: 75,
            column: 67
          }
        }, {
          start: {
            line: 75,
            column: 70
          },
          end: {
            line: 75,
            column: 78
          }
        }],
        line: 75
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0
    },
    f: {
      "0": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0, 0, 0, 0],
      "6": [0, 0],
      "7": [0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "10d618a1704ebbf98f4d8227a6fef70350ee77ac"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_19fjrgvlpp = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_19fjrgvlpp();
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var defaultProps = (cov_19fjrgvlpp().s[0]++, {
  fullWidthContent: false,
  showFullBorder: true
});

/** @deprecated */
cov_19fjrgvlpp().s[1]++;
var ContentCard = function ContentCard(_ref) {
  var id = _ref.id,
    forceBorder = _ref.forceBorder,
    fullWidthContent = _ref.fullWidthContent,
    showFullBorder = _ref.showFullBorder,
    thickBorder = _ref.thickBorder,
    title = _ref.title,
    isInlay = _ref.isInlay,
    children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  cov_19fjrgvlpp().f[0]++;
  cov_19fjrgvlpp().s[2]++;
  return /*#__PURE__*/_react["default"].createElement(_core.Card, _extends({
    p: "".concat(_eero.space[7], "px"),
    width: "100%",
    position: "relative",
    flexDirection: "column",
    id: id,
    background: isInlay ? (cov_19fjrgvlpp().b[0][0]++, 'neutrals10') : (cov_19fjrgvlpp().b[0][1]++, null),
    borderBottomWidth: thickBorder ? (cov_19fjrgvlpp().b[1][0]++, '10px') : (cov_19fjrgvlpp().b[1][1]++, showFullBorder ? (cov_19fjrgvlpp().b[2][0]++, '1px') : (cov_19fjrgvlpp().b[2][1]++, 0)),
    borderBottomColor: thickBorder ? (cov_19fjrgvlpp().b[3][0]++, 'neutrals30') : (cov_19fjrgvlpp().b[3][1]++, 'neutrals10'),
    borderBottomStyle: "solid",
    _after: {
      borderBottom: showFullBorder ? (cov_19fjrgvlpp().b[4][0]++, "1px solid ".concat(_eero.colors.neutrals10)) : (cov_19fjrgvlpp().b[4][1]++, 0),
      bottom: 0,
      content: '" "',
      position: 'absolute',
      left: "".concat(_eero.space[8], "px"),
      right: "".concat(_eero.space[8], "px")
    },
    _last: {
      borderBottom: (cov_19fjrgvlpp().b[5][0]++, !forceBorder) && ((cov_19fjrgvlpp().b[5][1]++, showFullBorder) || (cov_19fjrgvlpp().b[5][2]++, thickBorder)) && (cov_19fjrgvlpp().b[5][3]++, 0)
    }
    // NOTE: Leaving these classes in for legacy components/tests dependent on the class names
    ,
    className: (0, _classnames["default"])('od-content-card', {
      'od-content-card-force-border': forceBorder,
      'od-content-card-full-border': showFullBorder
    })
  }, rest), (cov_19fjrgvlpp().b[6][0]++, title) && (cov_19fjrgvlpp().b[6][1]++, /*#__PURE__*/_react["default"].createElement(_core.Heading, {
    size: "UNSAFE_h3",
    as: "h3",
    mt: 0,
    mb: "".concat(_eero.space[4], "px"),
    fontSize: "s3",
    color: "neutrals100"
  }, title)), fullWidthContent ? (cov_19fjrgvlpp().b[7][0]++, /*#__PURE__*/_react["default"].createElement(_core.Box, {
    mx: "-".concat(_eero.space[8], "px")
  }, children)) : (cov_19fjrgvlpp().b[7][1]++, children));
};
cov_19fjrgvlpp().s[3]++;
ContentCard.defaultProps = defaultProps;
var _default = exports["default"] = ContentCard;